(function($, undefined) {
	'use strict';

	var toggleAccordion = function() {
		var t = $(this);
		var id = t.closest('.accordion-outer-ctn').attr('data-id');

		if ($('.accordion-outer-ctn.open').length && $('.accordion-outer-ctn.open').attr('data-id') !== id) {
			$('.accordion-outer-ctn.open').find('.accordion-content').slideUp();
			$('.accordion-outer-ctn.open').removeClass('open');
		}

		t.closest('.accordion-outer-ctn').toggleClass('open').find('.accordion-content').slideToggle();
	};

	var init = function() {
		$('.accordion-header-ctn').click(toggleAccordion);
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

